/** *
 *  极速开方
 */

import Main from '@components/main/main'

const quickPrescribe = {
  path: '/quickPrescribe',
  component: Main,
  redirect: '/quickPrescribe',
  children: [{
    name: 'quickPrescribe',
    path: '/quickPrescribe',
    component: () => import ('@/pages/quickPrescribe/pages/list'),
    meta: {
      auth: true,
      title: '充值明细'
    }
  },
  {
    name: 'recharge',
    path: '/quickPrescribe/recharge',
    component: () => import ('@/pages/quickPrescribe/pages/recharge'),
    meta: {
      auth: true,
      title: '充值套餐'
    }
  }]
}

export default quickPrescribe




// WEBPACK FOOTER //
// ./src/pages/quickPrescribe/index.js